module.exports = __webpack_public_path__ + "static/media/login-background-image.a66a55f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-background-image.jpg
// module id = 685
// module chunks = 0